import * as Yup from "yup";

export const validationSchema = Yup.object().shape({
  comment: Yup.string().max(300, "Maximum Word count is 300!"),
});
